import { memo } from "react";
import { Flex } from "../../flex";
import { Text } from "../../text";
export interface RedoChatTextProps {
  name?: string;
  isResponder: boolean;
  chatBlock: string[];
}

export const RedoChatText = memo(function RedoChatText({
  name,
  isResponder,
  chatBlock,
}: RedoChatTextProps) {
  return (
    <Flex flexDirection="column" gap="sm">
      {name && (
        <Text fontSize="xs" fontWeight="thin">
          {name}
        </Text>
      )}
      {chatBlock.map((text, index) => (
        <Flex
          align={isResponder ? "flex-start" : "flex-end"}
          flexDirection="column"
          gap="sm"
          justify={isResponder ? "flex-start" : "flex-end"}
          key={index}
        >
          <Flex
            bgColor={isResponder ? "tertiary" : "blue-primary"}
            borderColor={isResponder ? "secondary" : "none"}
            borderStyle={isResponder ? "solid" : "none"}
            borderWidth={isResponder ? "1px" : "none"}
            p="md"
            radius="sm"
            topLeftRadius={isResponder ? "none" : "sm"}
            topRightRadius={isResponder ? "sm" : "none"}
          >
            <Text
              fontSize="sm"
              fontWeight="regular"
              textColor={isResponder ? "primary" : "primary-on-brand"}
            >
              {text}
            </Text>
          </Flex>
        </Flex>
      ))}
    </Flex>
  );
});
